"use strict";
/* globals module */
/**
 * @module articleSubscriptionsCommentRequiresModerationClient
 * @description  Article Subscriptions Comment Requires Moderation Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsCommentRequiresModerationClient` uses `articleSubscriptionsCommentRequiresModerationRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../../httpApi");
var __1 = require("../");
var ArticleSubscriptionsCommentRequiresModerationClient = /** @class */ (function () {
    function ArticleSubscriptionsCommentRequiresModerationClient(articleSubscriptionsCommentRequiresModerationRoute, apiClient) {
        this.articleSubscriptionsCommentRequiresModerationRoute = articleSubscriptionsCommentRequiresModerationRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSubscriptionsCommentRequiresModerationClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleSubscriptionsCommentRequiresModerationRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Subscribes user to article comment requires moderation updates. Returns a promise that is resolved once the subscribe action has been performed.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleCommentRequiresModerationClient.subscribe(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentRequiresModerationClient.prototype.subscribe = function (data) {
        return this.apiClient.post(this.articleSubscriptionsCommentRequiresModerationRoute.subscribe(data), data);
    };
    /**
     * Determines whether user is subscribed to article comment requires moderation updates. Returns a promise that is resolved once the isSubscribed action has been performed.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleCommentRequiresModerationClient.isSubscribed(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentRequiresModerationClient.prototype.isSubscribed = function (data) {
        return this.apiClient.get(this.routeDefinition.isSubscribed(data));
    };
    /**
     * Unsubscribe user from article comment requires moderation updates. Returns a promise that is commentReported once the unSubscribe action has been performed.
     * @method
     * @param data The unsubscribe information.
     * @returns A promise that is commentReported once the unSubscribe action has been performed.
     * @example articleCommentRequiresModerationClient.unSubscribed(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentRequiresModerationClient.prototype.unSubscribed = function (data) {
        return this.apiClient.delete(this.routeDefinition.unSubscribe(data));
    };
    var _a, _b;
    ArticleSubscriptionsCommentRequiresModerationClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentRequiresModerationRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentRequiresModerationRoute !== "undefined" && __1.ArticleSubscriptionsCommentRequiresModerationRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSubscriptionsCommentRequiresModerationClient);
    return ArticleSubscriptionsCommentRequiresModerationClient;
}());
exports.ArticleSubscriptionsCommentRequiresModerationClient = ArticleSubscriptionsCommentRequiresModerationClient;
